import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Row, CardImg, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { dAPI_Delete_Ingetration, dAPI_Delete_PhoneIngetration_Group } from '../../../../../constants/APIs';
import XolaIntegration from './XolaIntegration';
import XolaLogo from '../images/xola.png';

export default function XolaIntegrationThumb({ integration, allProperties, LoadIntegrations }) {

    const [deleteVisible, setDeleteVisible] = useState(false);
    const [formatedProperties, setFormatedProperties] = useState('');
    const [moreProperties, setMoreProperties] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    useEffect(() => {
        const result = integration.properties.map(id => {
            return allProperties.find(elem => elem.id === id);
        });
        if (result.length > 2) {
            const filterResults = result.slice(0, 2);
            setFormatedProperties(filterResults.map(elem => elem.name).join(", "));
            setMoreProperties('and ' + (result.length - filterResults.length) + ' more')
        }
        else {
            const filterResults = result.filter(elem => elem !== undefined);
            setFormatedProperties(filterResults.map(elem => elem.name).join(", "));

        }
    }, [integration, allProperties]);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Ingetration}/${integration.id}/?group_id=${getGroupID()}`,
        }).then(res => {
            toggle();
            LoadIntegrations();
        });
    };
    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This integration will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Fragment>
            {integration ? <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                <Card className="d-flex flex-row" style={{ height: '215px' }}>

                    <h3 className="integrationChannel">
                        <img
                            src={XolaLogo}
                            alt="Logo"
                            style={{ maxWidth: '100px' }}
                        />
                    </h3>
                    <a href="#/" className="integrationremove"
                        onClick={toggle}
                    >
                        {" "}
                        <h3 className="iconsminds-remove" />{" "}
                    </a>

                    <CardBody>
                        <Row className="mt-3">                        
                            <Colxx xxs="12" className="mb-2 text-center">
                                
                                    <div className="mb-1">
                                        <p><b>Name</b></p>
                                        {integration.name}
                                    </div>
                                    </Colxx>                               
                                    <Colxx xxs="12" className="mb-0 text-center">                              
                                    <div className="mb-2">
                                        <p><b>Business Name</b></p>
                                        <b>{formatedProperties} </b>
                                        <b>{moreProperties}</b>
                                    </div>
                                    </Colxx>                              
                                    <Colxx xxs="12" className="mb-1 text-center">
                                    <Button
                                        className="ml-2"
                                        size="xs"
                                        color="success"
                                        outline
                                        style={{ marginTop: '20px', display: 'inline-block' }}
                                        onClick={() => setIsEditing(!isEditing)}
                                    >
                                        Edit
                                    </Button>
                                
                            </Colxx>
                        </Row>
                    </CardBody>
                </Card>
            </Colxx> : null}
            {isEditing ? (
                <Row>
                    <Colxx xxs="12">
                        <Row>
                            <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12">
                                <XolaIntegration
                                    LoadIntegrations={LoadIntegrations}
                                    visible={isEditing}
                                    toggle={() => {
                                        setIsEditing(!isEditing);
                                    }}
                                    id={integration.id}
                                />
                            </Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                        </Row>
                    </Colxx>
                </Row>
            ) : null}
            {generateDeleteButton()}
        </Fragment>
    );
}
